/**
 * KAN-834: регистрация service worker приложения менеджера (public/sw.js).
 * Вызывается из main.tsx только в production-сборке. Ошибка регистрации не
 * мешает работе: приложение просто не будет работать без сети.
 * updateViaCache: 'none': nginx отдаёт *.js с долгим кэшем, а новый sw.js
 * должен приезжать сразу после выкатки.
 */
export async function registerServiceWorker(nav: Navigator = navigator): Promise<boolean> {
  if (!('serviceWorker' in nav) || !nav.serviceWorker) return false;
  try {
    await nav.serviceWorker.register('/sw.js', { scope: '/', updateViaCache: 'none' });
    return true;
  } catch {
    return false;
  }
}
